import { useOutletContext } from 'react-router-dom';

import { LegalAgreementHtmlBlock } from '../widget-ui/legal-agreement-html-block';
import { formatISODate } from '../widget-lib/format-date';
import { useWidgetSeo } from '../widget-hooks/use-widget-seo';
import type { LegalDocumentsOutletContext } from './legal_LegalDocumentsOutlet';

export default function LegalRulesPage() {
  useWidgetSeo(
    'Правила использования',
    'Правила посещения и условия оказания услуг.'
  );
  const { data } = useOutletContext<LegalDocumentsOutletContext>();
  const html = data.PlatformUserRulesText;
  if (html == null || html === '') {
    return (
      <article className="space-y-4 w-full min-w-0 px-4 py-4">
<h1 className="text-xl font-semibold tracking-tight">Пользовательское соглашение платформы</h1>
        <p className="text-sm text-[var(--text-muted)]">Текст пользовательского соглашения пока не задан.</p>
      </article>
    );
  }
  return (
    <article className="space-y-4 w-full min-w-0 px-4 py-4">
      <h1 className="text-xl font-semibold tracking-tight">Пользовательское соглашение</h1>
      {data.PlatformUserRulesDate && (
        <p className="text-xs text-[var(--text-muted)]">от {formatISODate(data.PlatformUserRulesDate)}</p>
      )}
      <LegalAgreementHtmlBlock html={html} />
    </article>
  );
}
